/**
 * Model for on board organisation request.
 */
export class OnBoardRequestModel {
    orgId: number;
    workflowType: WorkflowType;
}

export enum WorkflowType {
    WF_ONBOARD_WTT = <any>'WF_ONBOARD_WTT',
    WF_ONBOARD_WWFT = <any>'WF_ONBOARD_WWFT',
    WF_RISK_PROFILE = <any>'WF_RISK_PROFILE',
    WF_REVIEW = <any>'WF_REVIEW',
    WF_SANCTIONMATCH = <any>'WF_SANCTIONMATCH',
    WF_PEP = <any>'WF_PEP',
    WF_OFFBOARD = <any>'WF_OFFBOARD',
    WF_TRANSACTION_OUT_OF_ANY_PROFILE = <any>'WF_TRANSACTION_OUT_OF_ANY_PROFILE',
    WF_TRANSACION_ACCEPTANCE = <any>'WF_TRANSACION_ACCEPTANCE',
    WF_TRANSACTION_EDIT = <any>'WF_TRANSACTION_EDIT',
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/onboard-request.model.ts